import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  AddCmsasizep,
  DeleteCmsasizep,
  GetCmsasizepDetails,
  UpdateCmsasizep,
  GetCBSA,
} from "../../../../api/User/ACG/CbsaSizePlanApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import { Size_Rate } from "../../../../Utils/constants";
import CustomInputField from "../../../../components/common/CustomInputField";
import Required from "../../../../components/Required";

const schema = Yup.object().shape({
  cmsa: Yup.string()
    .notOneOf(["Select CBSA"], "Please select CBSA")
    .required("Please select CBSA"),
  size: Yup.string()
    .notOneOf(["Select Size"], "Please select size")
    .required("Please select size"),
  rate_Type: Yup.string()
    .notOneOf(["Select Rate"], "Please select rate type")
    .required("Please select rate type"),
  rate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter rate"),
});

const CbsaSizePlan = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [isGetData, setIsGetData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [cbsaData, setCbsaData] = useState([]);
  const buttonRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const column = [
    { title: "CBSA", field: "cmsa" },
    { title: "Size", field: "size" },
    { title: "Rate Type", field: "rate_Type" },
    { title: "Rate", field: "rate" },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getIndustryRiskData();
      GetCBSA().then((res) => {
        if (res.status === 200 || res.status === 204) {
          setCbsaData(res.data);
        }
      });
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getIndustryRiskData();
    GetCBSA().then((res) => {
      if (res.status === 200 || res.status === 204) {
        setCbsaData(res.data);
      }
    });
  }, []);

  const getIndustryRiskData = () => {
    setIsLoading(true);
    GetCmsasizepDetails()
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    if (witchAction === "add") {
      let payload = {
        id: 0,
        cmsa: values.cmsa,
        size: values.size,
        rate_Type: values.rate_Type,
        rate: +values.rate,
      };
      const newItem = {
        id: 0,
        cmsa: values.cmsa,
        size: values.size,
        rate_Type: values.rate_Type,
        rate: +values.rate,
      };
      setData([...data, newItem]);
      AddCmsasizep(payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("new");
          setShowModal(false);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      let payload = {
        id: selectedRowData.id,
        cmsa: values.cmsa,
        size: values.size,
        rate_Type: values.rate_Type,
        rate: +values.rate,
      };
      const updatedData = data.map((item, index) => {
        if (index === selectedRowData?.tableData.id) {
          return {
            ...item,
            cmsa: values.cmsa,
            size: values.size,
            rate_Type: values.rate_Type,
            rate: +values.rate,
          };
        }
        return item;
      });
      setData(updatedData);
      UpdateCmsasizep(payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("update");
          setShowModal(false);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            CBSA By Size & Plan
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteCmsasizep(selectedRowData?.id).then((res) => {
                  if (res.status === 200 || res.status === 204) {
                    toastFile("delete");
                    setIsGetData(true);
                    setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                cmsa: selectedRowData ? selectedRowData.cmsa : "Select CBSA",
                size: selectedRowData ? selectedRowData.size : "Select Size",
                rate_Type: selectedRowData
                  ? selectedRowData.rate_Type
                  : "Select Rate",
                rate: selectedRowData ? selectedRowData.rate : 0,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-2 gap-3">
                    <Form.Group>
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        CBSA
                        <Required />
                      </Form.Label>
                      <Form.Select
                        className="rounded-0"
                        style={Fontstyling.label}
                        name="cmsa"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          values.cmsa === "Select CBSA" && touched.cmsa
                        }
                      >
                        <option value={"Select CBSA"}>Select CBSA</option>
                        {cbsaData.map(({ CMSA: item }) => (
                          <option value={item} selected={values.cmsa === item}>
                            {item}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.cmsa}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Size
                        <Required />
                      </Form.Label>
                      <Form.Select
                        className="rounded-0"
                        style={Fontstyling.label}
                        name="size"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          values.size === "Select Size" && touched.size
                        }
                      >
                        {Size_Rate.Size.map((item) => (
                          <option value={item} selected={values.size === item}>
                            {item}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.size}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Rate Type
                        <Required />
                      </Form.Label>
                      <Form.Select
                        className="rounded-0"
                        style={Fontstyling.label}
                        name="rate_Type"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          values.rate_Type === "Select Rate" &&
                          touched.rate_Type
                        }
                      >
                        {Size_Rate.Rate.map((item) => (
                          <option
                            value={item}
                            selected={values.rate_Type === item}
                          >
                            {item}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.rate_Type}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <CustomInputField
                      label="Rate"
                      name="rate"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                  </Row>
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{ fontSize: "12px" }}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add CBSA By Size & Plan
        </CustomButton>
      </div>
      <CustomMaterialTable
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default CbsaSizePlan;
